
export function getGetSafeStaffMembersRoute() {
    return "safe/staff-members/get";
}